import { FEATURE_FLAGS } from "@constants";
import { ProposalyType } from "@tsTypes/proposaly";
import { RequestableType } from "@tsTypes/requests";
import { lazyWithRetry } from "@utils/appUtils";
import { Route } from "react-router-dom";

const OldProposalPage = lazyWithRetry(() => import("../views/ProposalPageOld"));
const ProposalPage = lazyWithRetry(() => import("../views/ProposalPage"));

const routes = [
  <Route exact path="/proposal/:slug" key="proposal_page_routes/1">
    {FEATURE_FLAGS.NEW_PROPOSAL_PAGE ? (
      <ProposalPage proposalyType={ProposalyType.PROPOSAL} />
    ) : (
      <OldProposalPage />
    )}
  </Route>,
  <Route exact path={"/request_for_expert_proposals/:slug"} key="proposal_page_routes/2">
    {FEATURE_FLAGS.NEW_PROPOSAL_PAGE ? (
      <ProposalPage proposalyType={ProposalyType.REQUEST_FOR_EXPERT_PROPOSAL} />
    ) : (
      <OldProposalPage requestableType={RequestableType.REQUEST_FOR_EXPERT} />
    )}
  </Route>,
  <Route exact path="/startup_program_proposal/:slug" key="proposal_page_routes/3">
    {FEATURE_FLAGS.NEW_PROPOSAL_PAGE ? (
      <ProposalPage proposalyType={ProposalyType.REQUEST_FOR_STARTUP_PROPOSAL} />
    ) : (
      <OldProposalPage requestableType={RequestableType.REQUEST_FOR_STARTUP} />
    )}
  </Route>,
];

export default routes;
